import Components from 'components/common/ComponentIndex';
import {
    FormComponentValue,
    FormControlProps,
    FormControlRadioProps,
    FormControlDataSourceProps,
    FormControlSwitchProps,
    FormControlTinyMCEProps,
    FormControlTagsProps,
    FormControlDateRangeProps,
    FormControlCommonLazyLoad,
    FormControlPeriodFieldProps,
    FormControlCompareFieldProps,
    FormControlMigrationCheckboxProps,
    FormControlToggleButtonGroupProps,
} from './layout/control';
import { ControllerRenderProps } from 'react-hook-form/dist/types/controller';
import { Params as UrlParams } from 'react-router';
import { FormGenericYNControlProps } from 'components/common/form/layout/control/FormGenericYNControl';
import { FormControlSelectMapGridProps } from 'components/common/select-map-grid';
import { FormControlIndexManagerProps } from 'app/editor/dataset/IndexManager';
import { FormControlCommandDetailsDownloadProps } from 'app/editor/dataset/CommandDetailsDownload';
import { FormElementProps } from './index';
import { FormControlGridProps } from 'components/common/form/FormGridComponent';
import { FormControlShowDataProps } from 'components/common/form/data-fetch-command/ShowData';
import { ElementViewerInfoProps } from 'components/common/element-info/ElementInfo';
import { FormControlLogoImageProps } from 'components/branding';
import { FormControlUploadFileProps } from 'components/common/upload-control/UploadFile';
import { FormControlUploadImageProps } from 'components/common/upload-control/UploadImage';
import { FormTermsControlProps } from 'components/common/terms-control';
import { FormControlFolderContentProps } from 'app/editor/folder/FolderContent';
import { FormBurstControlProps } from 'app/notification/burst/BurstControl';
import { FormBurstSendToGroupControlProps } from 'app/notification/send-now/SendToGroup';
import { FormControlMobilePreferenceProps } from 'app/preferences';
import { FormControlNotificationFrequencyProps } from 'app/distribution/notification-schedules/NotificationFrequency';
import { FormControlSyncWithGitProps } from 'app/editor/page-template/index';
import { FormControlAssetsTreeProps } from 'app/editor/page-template/AssetsTree';
import { FormControlFoldersTreeProps } from 'app/content/index';
import { FormControlReportContentEditorProps } from 'app/editor/report';
import { FormControlChangeTemplateProps } from 'app/editor/page';
import { FormControlDropFileUploadProps } from 'app/editor/asset';
import { FormControlAutoSyncProps } from 'app/extreport/AutoSyncInfo';
import { FormControlRuleConditionProps } from 'app/editor/content-workflow/RuleCondition';
import { FormEmailSubjectLineControlProps } from 'app/notification/burst/EmailSubjectLine';
import { FormControlInvolvedFieldsProps } from 'app/editor/content-workflow/InvolvedFields';
import { FormControlSimpleScheduleProps } from 'app/notification/simple-schedule/index';
import { FormControlBurstFolderSelectProps } from 'app/notification/folder-select/BurstFolderSelect';
import { FormControlLineageFormButtonProps } from 'components/lineage/LineageFormButton';
import { FormControlElementSourceProps } from 'app/content-workflow/element-editor/ElementSource';
import { FormControlContentFolderSelectProps } from 'app/content-workflow/element-editor/ContentFolderSelect';
import { ExternalContentCustomUrlControlProps } from 'app/editor/element/ext-content/ExternalContentCustomUrl';
import { FormBurstSharingAlertProps } from 'app/notification/sharing-alert';
import { getPkId } from 'components/common/form/formTools';
import { FormControlPageEntityFsAccessProps } from 'app/editor/page/entity/FsAccess';
import { getFormComponentBuilderByKey } from './builderIndex';

export default function buildFormControlProperties(
    elementProps: FormElementProps,
    { onChange, value }: ControllerRenderProps,
    componentValues?: Array<FormComponentValue>,
    afterChange: (event: any) => void = (event: any) => {},
): {
    isValid: boolean;
    controlProps: FormControlProps;
    componentName: any;
} {
    const componentKey = elementProps.component.component;
    const controlPropsObj = {
        uid: elementProps.component.uid,
        form: elementProps.form,
        name: elementProps.component.name,
        label: elementProps.componentProps.label,
        addonLabel: elementProps.componentProps.addonLabel,
        translate: elementProps.componentProps.translate ?? true,
        helperText: elementProps.componentProps.helperText,
        value: value ?? '',
        onChange: (event) => {
            onChange(event);
            afterChange(event);
        },
        helper: elementProps.component.helper,
        readOnly: elementProps.componentProps.readOnly ?? false,
        // defaultValue: elementProps.data[elementProps.component.name],
        formIgnoreSubmit: elementProps.componentProps.formIgnoreSubmit ?? false,
        tooltip: elementProps.componentProps.tooltip,
        controlClass: elementProps.componentProps.controlClass,
        labelClass: elementProps.componentProps.labelClass,
        width: elementProps.componentProps.width,
    } as FormControlProps;

    let controlProps = { ...controlPropsObj };
    let validComponent = true;
    let componentName = Components[componentKey];

    // TODO:
    const getUploadComponentProps = function () {
        return {
            ...controlPropsObj,
            accept: elementProps.componentProps?.accept,
            view: elementProps.componentProps?.view ?? 'button',
            multiple: elementProps.componentProps?.multiple ?? false,
            maxFileSizeMB: Number(elementProps.componentProps?.maxFileSizeMB ?? 512),
            removeActionText: elementProps.componentProps?.removeActionText ?? 'remove_action_text',
            removeActionView: elementProps.componentProps?.removeActionView ?? 'link',
            removeButtonColor: elementProps.componentProps?.removeButtonColor ?? undefined,
            emptyStateTooltip: elementProps.componentProps?.emptyStateTooltip ?? undefined,
            showRemoveAction: elementProps.componentProps?.showRemoveAction ?? undefined,
            buttonTextFilled: elementProps.componentProps?.buttonTextFilled ?? undefined,
            buttonText: elementProps.componentProps?.buttonText ?? undefined,
            inputPlaceholder: elementProps.componentProps?.inputPlaceholder ?? undefined,
            buttonStartIcon: elementProps.componentProps?.buttonStartIcon ?? undefined,
            buttonFilledStartIcon: elementProps.componentProps?.buttonFilledStartIcon ?? undefined,
            previewsList: elementProps.componentProps?.previewsList ?? [],
            previewsPlaceholder: elementProps.componentProps?.previewsPlaceholder ?? undefined,
            sx: elementProps.componentProps?.sx ?? undefined,
            id: elementProps.componentProps?.id ?? undefined,
            ignoreStateField: elementProps.componentProps?.ignoreStateField ?? undefined,
            onChange: (event: any) => {
                const result = onChange(event.target?.files);
                afterChange(event.target?.files);
                return result;
            },
            ajaxApiUrl: elementProps.componentProps?.ajaxApiUrl ?? '',
            ajaxApiRemoveUrl: elementProps.componentProps?.ajaxApiRemoveUrl ?? '',
            onAjaxUploadResult: elementProps.componentProps?.onAjaxUploadResult ?? ((response: any): void => {}),
            onAjaxRemoveResult: elementProps.componentProps?.onAjaxRemoveResult ?? ((response: any): void => {}),
            onFilesChange: elementProps.componentProps?.onFilesChange ?? undefined,
        };
    };

    const className = getFormComponentBuilderByKey(componentKey);
    if (className != undefined) {
        const builder = new className(elementProps, controlProps, componentValues);
        return {
            isValid: true,
            controlProps: builder.prepareProps(value, onChange, afterChange),
            componentName: componentName,
        };
    }

    switch (componentKey) {
        case 'SystemStatus':
        case 'FormHidden':
        case 'ImportErrorStack':
            controlProps = { ...controlPropsObj };
            break;
        case 'GridComponent':
            controlProps = {
                ...controlPropsObj,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
                lazy: elementProps.componentProps?.lazy ?? true,
                elementProps: elementProps,
                formGrid: true,
                setFormDirty: elementProps.componentProps?.setFormDirty ?? false,
                relatedFields: elementProps.componentProps?.relatedFields ?? [],
                removeHeaderIndent: elementProps.componentProps?.removeHeaderIndent ?? false,
                gridDescription: elementProps.componentProps?.gridDescription,
                jsonStore: elementProps.componentProps?.jsonStore,
                injectedComponents: elementProps.componentProps?.injectedComponents ?? [],
            } as FormControlGridProps;
            componentName = require('components/common/form/FormGridComponent').default;
            break;
        case 'FormCheckboxMigration':
            controlProps = {
                ...controlPropsObj,
                onChange: (value: any, checked: any) => {
                    const v = elementProps.componentProps?.asBoolean ? checked : checked ? 'Y' : 'N';
                    onChange(v);
                    afterChange(v);
                },
                type: elementProps.componentProps?.type ?? '',
                checked: elementProps.componentProps?.asBoolean ? value : value == 'Y',
                disabled: elementProps.componentProps?.disabled ?? false,
                lastExported: elementProps.componentProps?.lastExported ?? '',
            } as FormControlMigrationCheckboxProps;
            break;
        case 'FormGenericYNControl':
            controlProps = {
                ...controlPropsObj,
                data: componentValues,
            } as FormGenericYNControlProps;
            break;
        case 'FormCompareField':
        case 'FormCompareFieldBetween':
            controlProps = {
                ...controlPropsObj,
                data: componentValues,
                type: elementProps.componentProps?.type ?? '',
                variant: elementProps.componentProps?.variant ?? 'danger',
                extraText: elementProps.componentProps?.extraText ?? '',
                rangeEndName: elementProps.componentProps?.rangeEndName ?? '',
                rangeStartName: elementProps.componentProps?.rangeStartName ?? '',
                betweenLabel: elementProps.componentProps?.betweenLabel ?? '',
                extraTextBadge: elementProps.componentProps?.extraTextBadge ?? '',
                color: elementProps.componentProps?.color ?? false,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
            } as FormControlCompareFieldProps;
            break;
        case 'FormDateRange':
            controlProps = {
                ...controlPropsObj,
                selectedDates: value ?? '',
                defaultValue: elementProps.componentProps?.defaultValue ?? [],
            } as FormControlDateRangeProps;
            break;
        case 'FormPeriodField':
            controlProps = {
                ...controlPropsObj,
                data: componentValues,
                unitFieldName: elementProps.componentProps?.unitFieldName ?? '',
                periodFieldName: elementProps.componentProps?.periodFieldName ?? '',
                skipValidationMessage: elementProps.componentProps?.skipValidationMessage ?? false,
            } as FormControlPeriodFieldProps;
            break;
        case 'FormSwitch':
            const { disabled = false, checkedValue = 'Y', uncheckedValue = 'N' } = elementProps.componentProps;
            const defaultValue = value > '' ? value : uncheckedValue || checkedValue;
            const reversed = elementProps.componentProps?.reversed ?? false;
            controlProps = {
                ...controlPropsObj,
                disabled,
                checked: defaultValue === (reversed ? uncheckedValue : checkedValue),
                onChange: (_, checked: boolean) => {
                    if (reversed) {
                        onChange(checked ? uncheckedValue : checkedValue);
                        afterChange(checked ? uncheckedValue : checkedValue);
                    } else {
                        onChange(checked ? checkedValue : uncheckedValue);
                        afterChange(checked ? checkedValue : uncheckedValue);
                    }
                },
                onLabel: elementProps.componentProps?.onLabel,
                reversed,
                offLabel: elementProps.componentProps?.offLabel,
            } as FormControlSwitchProps;
            break;
        case 'FormTinyMCE':
            controlProps = {
                ...controlPropsObj,
                disabled: elementProps.componentProps.disabled,
                allowImageUpload: elementProps.componentProps?.allowImageUpload ?? false,
            } as FormControlTinyMCEProps;
            break;
        case 'FormRadioGroup':
            controlProps = {
                ...controlPropsObj,
                data: componentValues,
                isRow: elementProps.componentProps?.row ?? true,
                disabled: elementProps.componentProps?.disabled ?? false,
                defaultValue: elementProps.componentProps?.defaultValue ?? '',
                labelHelper: elementProps.componentProps?.labelHelper ?? '',
            } as FormControlRadioProps;
            break;
        case 'FormToggleButtonGroup':
            controlProps = {
                ...controlPropsObj,
                data: componentValues,
                isRow: elementProps.componentProps?.row ?? true,
                disabled: elementProps.componentProps?.disabled ?? false,
                fullWidth: elementProps.componentProps?.fullWidth ?? false,
                icons: elementProps.componentProps?.icons,
            } as FormControlToggleButtonGroupProps;
            break;
        case 'FormDataSource':
            controlProps = {
                ...controlPropsObj,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
                data: componentValues,
                elementProps: elementProps,
                editorType: elementProps.componentProps?.editorType ?? 'dataset',
            } as FormControlDataSourceProps;
            break;
        case 'FormTags':
            controlProps = {
                ...controlPropsObj,
                data: componentValues,
                elementProps: elementProps,
                fetchOnTab: elementProps.componentProps.fetchOnTab ?? '',
                dataUrl: elementProps.componentProps.dataUrl ?? '',
            } as FormControlTagsProps;
            break;
        case 'UploadFile':
            //@ts-ignore
            controlProps = {
                ...getUploadComponentProps(),
                hidePreview: elementProps.componentProps?.hidePreview ?? true,
                previewType: elementProps.componentProps?.previewType ?? 'text',
            } as FormControlUploadFileProps;
            break;
        case 'UploadImage':
            //@ts-ignore
            controlProps = {
                ...getUploadComponentProps(),
                hidePreview: elementProps.componentProps?.hidePreview ?? false,
                previewType: elementProps.componentProps?.previewType ?? 'image',
                previewImageContainer: elementProps.componentProps?.previewImageContainer ?? undefined,
            } as FormControlUploadImageProps;
            break;
        case 'ProfilePicture':
            //@ts-ignore
            controlProps = {
                ...getUploadComponentProps(),
                accept: 'image/*',
                hidePreview: elementProps.componentProps?.hidePreview ?? false,
                previewType: elementProps.componentProps?.previewType ?? 'image',
            } as FormControlUploadImageProps;
            break;
        case 'SelectMapGrid':
            controlProps = {
                ...controlPropsObj,
                async: elementProps.componentProps.async,
                selectMapData: elementProps.componentProps.data,
                settingsUrl: elementProps.componentProps.settingsUrl,
                hiddenColumns: elementProps.componentProps.hiddenColumns,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
            } as FormControlSelectMapGridProps;
            break;
        case 'BrandingLogoControl':
            controlProps = {
                ...controlPropsObj,
                imgUrl: elementProps.componentProps?.imgUrl ?? '',
                isCustom: elementProps.componentProps?.isCustom ?? false,
            } as FormControlLogoImageProps;
            break;
        case 'TermsControl':
            controlProps = {
                ...controlPropsObj,
                fetchUrl: elementProps.componentProps?.fetchUrl ?? '',
                fetchOnTab: elementProps.componentProps?.fetchOnTab ?? '',
                renderTags: elementProps.componentProps?.renderTags ?? true,
                renderTopics: elementProps.componentProps?.renderTopics ?? true,
                showHeader: elementProps.componentProps?.showHeader ?? true,
                shortForm: elementProps.componentProps?.shortForm ?? false,
                fieldName: elementProps.componentProps?.fieldName,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
            } as FormTermsControlProps;
            break;
        case 'RatingEngagement':
        case 'ElementEditorFeedback':
            controlProps = {
                ...controlPropsObj,
                fetchOnTab: elementProps.componentProps?.fetchOnTab ?? '',
            } as FormControlCommonLazyLoad;
            break;
        case 'BurstControl':
            controlProps = {
                ...controlPropsObj,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
                data: elementProps.component.componentStartValues,
                fetchUrl: elementProps.componentProps?.fetchUrl ?? '',
                fetchOnTab: elementProps.componentProps?.fetchOnTab ?? '',
            } as FormBurstControlProps;
            break;
        case 'SendToGroup':
            controlProps = {
                ...controlPropsObj,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
                userEmail: elementProps.componentProps?.userEmail ?? '',
                burstOptions: elementProps.componentProps?.burstOptions ?? [],
                adminsGridUrl: elementProps.componentProps?.adminsGridUrl ?? '',
                recipientsGridUrl: elementProps.componentProps?.recipientsGridUrl ?? '',
            } as FormBurstSendToGroupControlProps;
            break;
        case 'MobilePreference':
            controlProps = {
                ...controlPropsObj,
                analystData: elementProps.componentProps?.analyst ?? [],
                executiveBriefData: elementProps.componentProps?.executive_brief ?? [],
                connectedDevice: elementProps.componentProps?.connectedDevice ?? '',
                connectedDate: elementProps.componentProps?.connectedDate ?? '',
                connectedTime: elementProps.componentProps?.connectedTime ?? '',
                mobileExecutiveBriefAvailable: elementProps.componentProps?.mobileExecutiveBriefAvailable ?? false,
            } as FormControlMobilePreferenceProps;
            break;
        case 'IndexManager':
            controlProps = {
                ...controlPropsObj,
                pkId: getPkId(elementProps.pk, elementProps.urlParams),
                datasetName: elementProps.data?.name ?? '',
            } as FormControlIndexManagerProps;
            break;
        case 'FolderContent':
            controlProps = {
                ...controlPropsObj,
                pkId: getPkId(elementProps.pk, elementProps.urlParams),
                baseUrl: elementProps.componentProps?.baseUrl ?? '',
                storeTreeCountInForm: elementProps.componentProps?.storeTreeCountInForm ?? false,
            } as FormControlFolderContentProps;
            break;
        case 'NotificationFrequency':
            controlProps = {
                ...controlPropsObj,
                timeSelectLabel: elementProps.componentProps?.timeSelectLabel ?? '',
            } as FormControlNotificationFrequencyProps;
            break;
        case 'CommandDetailsDownload':
            controlProps = {
                ...controlPropsObj,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
                downloadUrl: elementProps.componentProps?.downloadUrl ?? '',
            } as FormControlCommandDetailsDownloadProps;
            break;
        case 'ShowData':
            controlProps = {
                ...controlPropsObj,
                pkId: getPkId(elementProps.pk, elementProps.urlParams),
                dataPreviewUrl: elementProps.componentProps.dataPreviewUrl ?? '',
            } as FormControlShowDataProps;
            break;
        case 'ElementInfo':
            controlProps = {
                ...controlPropsObj,
                data: elementProps.data,
                editorType: elementProps.componentProps.editorType ?? '',
            } as ElementViewerInfoProps;
            break;
        case 'AssetsTree':
            controlProps = {
                ...controlPropsObj,
                pkId: getPkId(elementProps.pk, elementProps.urlParams),
                baseUrl: elementProps.componentProps?.baseUrl ?? '',
                assetEditUrl: elementProps.componentProps?.assetEditUrl ?? '',
                assetDeleteUrl: elementProps.componentProps?.assetDeleteUrl ?? '',
            } as FormControlAssetsTreeProps;
            break;
        case 'SyncWithGit':
            controlProps = {
                ...controlPropsObj,
                pkId: getPkId(elementProps.pk, elementProps.urlParams),
                baseUrl: elementProps.componentProps?.baseUrl ?? '',
            } as FormControlSyncWithGitProps;
            break;
        case 'PageEntityFsAccess':
            controlProps = {
                ...controlPropsObj,
                pkId: getPkId(elementProps.pk, elementProps.urlParams),
            } as FormControlPageEntityFsAccessProps;
            break;
        case 'ReportContentEditor':
            controlProps = {
                ...controlPropsObj,
                isPermittedToEditDataset: elementProps.componentProps?.isPermittedToEditDataset ?? false,
            } as FormControlReportContentEditorProps;

            break;
        case 'FoldersTree':
            controlProps = {
                ...controlPropsObj,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
                fetchUrl: elementProps.componentProps?.fetchUrl ?? '',
                importUrl: elementProps.componentProps?.importUrl ?? '',
                fetchOnTab: elementProps.componentProps?.fetchOnTab ?? '',
            } as FormControlFoldersTreeProps;

            break;
        case 'ChangeTemplate':
            controlProps = {
                ...controlPropsObj,
                changeTemplateUrl: elementProps.componentProps?.changeTemplateUrl ?? '',
                getAvailableTemplatesUrl: elementProps.componentProps?.getAvailableTemplatesUrl ?? '',
                templateName: elementProps.componentProps?.templateName ?? '',
                templateId: elementProps.componentProps?.templateId ?? '',
            } as FormControlChangeTemplateProps;

            break;
        case 'DropFileUpload':
            controlProps = {
                ...controlPropsObj,
                gridName: elementProps.componentProps?.gridName ?? '',
                baseUrl: elementProps.componentProps?.baseUrl ?? '',
                parentFolderId: elementProps.componentProps?.parentFolderId ?? 0,
                allowedTypes: elementProps.componentProps?.allowedTypes ?? [],
            } as FormControlDropFileUploadProps;
            break;
        case 'AutoSyncInfo':
            controlProps = {
                ...controlPropsObj,
                name: elementProps.componentProps?.name ?? '',
            } as FormControlAutoSyncProps;
            break;
        case 'RuleCondition':
            controlProps = {
                ...controlPropsObj,
                availableStages: elementProps.componentProps?.availableStages ?? [],
            } as FormControlRuleConditionProps;
            break;
        case 'InvolvedFields':
            controlProps = {
                ...controlPropsObj,
                baseUrl: elementProps.componentProps?.baseUrl ?? '',
            } as FormControlInvolvedFieldsProps;
            break;
        case 'EmailSubjectLine':
            controlProps = {
                ...controlPropsObj,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
                fetchUrl: elementProps.componentProps?.fetchUrl ?? '',
            } as FormEmailSubjectLineControlProps;
            break;
        case 'SimpleSchedule':
            controlProps = {
                ...controlPropsObj,
                hideBottomInfo: elementProps.componentProps?.hideBottomInfo ?? false,
            } as FormControlSimpleScheduleProps;
            break;
        case 'ExternalContentCustomUrl':
            controlProps = {
                ...controlPropsObj,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
                mode: elementProps.componentProps?.mode ?? '',
                buildUrl: elementProps.componentProps?.buildUrl ?? '',
                report_type_id: elementProps.componentProps?.report_type_id ?? '',
                show_test_url: elementProps.componentProps?.show_test_url ?? true,
            } as ExternalContentCustomUrlControlProps;
            break;
        case 'BurstFolderSelect':
            controlProps = {
                ...controlPropsObj,
                pkId: getPkId(elementProps.pk, elementProps.urlParams),
                baseUrl: elementProps.componentProps?.baseUrl ?? '',
            } as FormControlBurstFolderSelectProps;
            break;
        case 'LineageFormButton':
            controlProps = {
                ...controlPropsObj,
                elementId: elementProps.componentProps?.elementId ?? '',
                elementType: elementProps.componentProps?.elementType ?? '',
            } as FormControlLineageFormButtonProps;
            break;
        case 'ElementSource':
            controlProps = {
                ...controlPropsObj,
                elementData: elementProps.componentProps?.elementData,
                sourceData: elementProps.componentProps?.sourceData,
            } as FormControlElementSourceProps;
            break;
        case 'ContentFolderSelect':
            controlProps = {
                ...controlPropsObj,
                treeData: elementProps.componentProps?.treeData,
            } as FormControlContentFolderSelectProps;
            break;
        case 'BurstSharingAlert':
            controlProps = {
                ...controlPropsObj,
                urlParams: {
                    ...elementProps.urlParams,
                    ...elementProps.componentProps?.urlParams,
                } as UrlParams,
                fetchUrl: elementProps.componentProps?.fetchUrl ?? '',
            } as FormBurstSharingAlertProps;
            break;
        default:
            validComponent = false;
    }
    return {
        isValid: validComponent,
        controlProps: controlProps,
        componentName: componentName,
    };
}
